import useGetProjectLocation from '@/api/queries/project/useGetProjectLocation';
import RedirectingPlaceholder from '@/ui/pages/legacyQuoteRedirectPage/RedirectingPlaceholder';
import { getUrlSearchParam } from '@payaca/helpers/urlHelper';
import { FC } from 'react';
import { Redirect, useLocation } from 'react-router-dom';

/**
 * Forwards `/quotes/new?dealId=` on to the builder's own create page, which
 * offers the same Proposal Template choice.
 */
const NewQuoteRedirectPage: FC = () => {
  const { search } = useLocation();
  const dealId = getUrlSearchParam(search, 'dealId');

  const { project, isError } = useGetProjectLocation(dealId ?? undefined);

  if (!dealId || isError) {
    return <Redirect to="/deals" />;
  }

  if (!project) {
    return <RedirectingPlaceholder label="Opening the proposal builder" />;
  }

  return project.version < 2 ? (
    <Redirect to={`/projects/${project.publicId}/proposals-and-invoices`} />
  ) : (
    <Redirect to={`/projects/${project.publicId}/proposals/new`} />
  );
};

export default NewQuoteRedirectPage;
